import { makeStyles, type StyleRules } from '~/utils/withStyles';

const useStyles = makeStyles(({ palette, spacing }) => ({
  '@keyframes checkMarkIn': {
    '0%': {
      opacity: 0,
      transform: 'scale(0) rotate(-45deg)',
    },
    '50%': {
      transform: 'scale(1.2) rotate(-45deg)',
    },
    '100%': {
      opacity: 1,
      transform: 'scale(1) rotate(0deg)',
    },
  },
  '@keyframes pulse': {
    '0%': {
      boxShadow: `0 0 0 0 ${palette.primary.main}40`,
    },
    '70%': {
      boxShadow: `0 0 0 ${spacing(1)} ${palette.primary.main}00`,
    },
    '100%': {
      boxShadow: `0 0 0 0 ${palette.primary.main}00`,
    },
  },
  '@keyframes scaleIn': {
    '0%': {
      opacity: 0,
      transform: 'scale(0.8)',
    },
    '50%': {
      transform: 'scale(1.1)',
    },
    '100%': {
      opacity: 1,
      transform: 'scale(1)',
    },
  },
  checkIcon: {
    animation: '$checkMarkIn 0.4s ease-out',
  },
  circle: {
    alignItems: 'center',
    borderRadius: '50%',
    display: 'flex',
    height: spacing(5),
    justifyContent: 'center',
    transition: 'background-color 0.3s ease, color 0.3s ease, border 0.3s ease',
    width: spacing(5),
  },
  circleCompleted: {
    animation: '$scaleIn 0.5s ease-out, $pulse 0.6s ease-out 0.3s',
    backgroundColor: palette.primary.main,
    color: '#fff',
  },
  circleError: {
    '& svg': {
      color: palette.error.main,
    },
    border: `2px solid ${palette.error.main}`,
    color: palette.error.main,
  },
  circlePaused: {
    backgroundColor: palette.grey[100],
    color: palette.grey[500],
  },
  circlePending: {
    backgroundColor: '#fff',
    color: palette.text.secondary,
  },
  connectorLine: {
    backgroundColor: palette.primary.main,
    height: `calc(100% + ${spacing(1)})`,
    left: spacing(2.5),
    position: 'absolute',
    top: spacing(5),
    transition: 'background-color 0.4s ease',
    width: spacing(0.25),
    zIndex: 0,
  },
  connectorLinePending: {
    backgroundColor: palette.grey[300],
  },
  container: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: spacing(4, 2),
  },
  errorBanner: {
    marginTop: spacing(0.5),
    width: '100%',
  },
  icon: {
    fontSize: spacing(2.5),
  },
  iconContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    zIndex: 1,
  },
  loadingWrapper: {
    '& .pm-loading-wrap': {
      height: `${spacing(6.25)} !important`,
      margin: '0 auto !important',
      width: spacing(6.25),
    },
    height: spacing(6.25),
    left: '50%',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: spacing(6.25),
  },
  progressHeader: {
    marginBottom: spacing(4),
  },
  stepContainer: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'row',
    marginBottom: spacing(3),
    position: 'relative',
    width: '100%',
  },
  stepContainerError: {
    color: palette.error.main,
  },
  stepContainerPaused: {
    opacity: 0.6,
  },
  stepContent: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    marginLeft: spacing(2),
  },
  stepDescription: {
    color: palette.text.secondary,
    fontSize: '0.875rem',
  },
  stepTitle: {
    fontWeight: 500,
    marginBottom: spacing(0.5),
  },

} as const satisfies StyleRules));

export default useStyles;
